import { isMobile, isTablet } from "react-device-detect";
import { isRaceNetMobileApp } from "utils/webViewTools";
import useBreakpoint from "./useBreakpoint";
import { styleGuide } from "theme";

const useIsMobile = () => {
    const mediaQuery = useBreakpoint(styleGuide.breakpoints.sm, "down");
    return ((mediaQuery || isMobile) && !isTablet) || isRaceNetMobileApp;
};

export default useIsMobile;
